import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  useToast
} from "@chakra-ui/react";

import { useEffect, useState } from "react";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  initialData?: any;
}

export default function FormModal({
  isOpen,
  onClose,
  onSave,
  initialData
}: Props) {

  const toast = useToast();

  const [form, setForm] = useState({
    numero: "",
    descricao: ""
  });

  useEffect(() => {
    if (initialData) {
      setForm({
        numero: initialData.numero ?? "",
        descricao: initialData.descricao ?? ""
      });
    } else {
      setForm({ numero: "", descricao: "" });
    }
  }, [initialData, isOpen]);

  function handleSave() {

    if (!form.numero) {
      toast({
        title: "Informe o número",
        status: "error"
      });
      return;
    }

    if (!form.descricao) {
      toast({
        title: "Informe a descrição",
        status: "error"
      });
      return;
    }

    onSave(form);
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />

      <ModalContent>
        <ModalHeader>
          {initialData ? "Editar Zona" : "Nova Zona"}
        </ModalHeader>

        <ModalBody>
          <VStack spacing={4}>

            <FormControl>
              <FormLabel>Número</FormLabel>
              <Input
                value={form.numero}
                onChange={(e) =>
                  setForm({
                    ...form,
                    numero: e.target.value
                  })
                }
              />
            </FormControl>

            <FormControl>
              <FormLabel>Descrição</FormLabel>
              <Input
                value={form.descricao}
                onChange={(e) =>
                  setForm({
                    ...form,
                    descricao: e.target.value
                  })
                }
              />
            </FormControl>

          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button mr={3} onClick={onClose}>
            Cancelar
          </Button>

          <Button colorScheme="blue" onClick={handleSave}>
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}